$(document).ready(function () {
  if ($('.swipebox').length) {
    $('body').on('click', '#swipebox-container', function(e) {
      var swipeboxTopBar = $('#swipebox-top-bar'),
          swipeboxBottomBar = $('#swipebox-bottom-bar');
      if(!$(e.target).is('img') &&
        !swipeboxTopBar.is(e.target) &&
        swipeboxTopBar.has(e.target).length === 0 &&
        !swipeboxBottomBar.is(e.target) &&
        swipeboxBottomBar.has(e.target).length === 0) {
        $('#swipebox-close').trigger('click');
      }
    });
  }
});
